// extracted by mini-css-extract-plugin
export default {"TextAreaContainer":"TextArea_TextAreaContainer__Usz-Y","TextArea":"TextArea_TextArea__1nmT+","Error":"TextArea_Error__GpdlY","ErrorText":"TextArea_ErrorText__Y9U7+"};